/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/SubmitAction",
  onSubmit,
  isSubmitting
  
}) {
let moveResourcesSubmitData = fromData.useDataSubmit({ viewPath,
context: 'move_resources',
})
let moveResourcesIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'move_resources',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 marginLeft={dtSpaceXs}
 data="move_resources"
 onClick={moveResourcesSubmitData}
 disabled={moveResourcesIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Submit"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}